import React from 'react';

import CSSModules from 'react-css-modules';

import {Button, ExternalLinkIcon} from '@edume/magnificent';

import {useSelector} from '../../../../state/hooks';
import {logClickedReferAFriendButton} from '../../../../tracking/amplitudeEvents/referAFriendEvents';
import {showExternalLinkIcon} from '../../../../utils/integrations';

import styles from './styles.module.scss';

type Props = {
  text: string;
};

const HeaderReferCtaComponent = ({text}: Props) => {
  const accessMethod = useSelector((state) => state.auth.get('accessMethod'));
  const withIcon = showExternalLinkIcon(accessMethod);
  const onClick = () => {
    const baseUrl = 'https://www.edume.com/refer-a-friend';
    const hostname = window.location.hostname;
    const utmParams = new URLSearchParams({
      utm_source: hostname,
      utm_medium: 'referral',
      utm_campaign: 'refer_a_friend',
    });

    const fullUrl = `${baseUrl}?${utmParams.toString()}`;

    window.open(fullUrl, '_blank');
    logClickedReferAFriendButton();
  };

  return (
    <div styleName={`button ${withIcon ? 'with-icon' : ''}`}>
      <Button
        type='primary'
        noMarginTop
        noMarginLeft
        onClick={onClick}
        dataAutomation='refer-cta-button'
      >
        {text}
        {withIcon && (
          <div styleName='icon-container'>
            <ExternalLinkIcon size='tiny' colour='white' />
          </div>
        )}
      </Button>
    </div>
  );
};

export const HeaderReferCta = CSSModules(HeaderReferCtaComponent, styles, {
  allowMultiple: true,
});
